<template lang="pug">
div
  .icon.is-small
    i.far.fa-comment
  | &nbsp;
  span {{ comment }}
</template>

<script>
export default {
  props: {
    comment: {
      required: true,
      type: String
    }
  }
}
</script>
